module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/ee497ac9cacc4c8eb99893d8d0c679e7.png";